'use client';

import type { PublicCourse } from '@arcane-ai/core/publishing/public';
import { useSessionUser } from '@arcane-ai/core/stores';
import { PublicCoursePage } from '@arcane-ai/ui/components/pages';

/** The session only switches the CTA; the server HTML always has sign-up. */
export default function CourseClient(props: {
  lng: string;
  course: PublicCourse;
  teacherHref?: string;
}) {
  return <PublicCoursePage {...props} signedIn={Boolean(useSessionUser())} />;
}
